import { Component, OnInit, Input, OnChanges, DoCheck } from '@angular/core';
import { each } from 'lodash';

@Component({
  selector: 'app-form-errors',
  templateUrl: './form-errors.component.html',
  styleUrls: ['./form-errors.component.sass']
})
export class FormErrorsComponent implements OnInit, DoCheck {
  @Input() for: any = null;
  @Input() errors: any = null;
  @Input() keys = {};
  @Input() touched = true;

  constructor() {}

  ngOnInit() {}

  ngDoCheck() {
    const errors = this.errors || (this.for && this.for.errors);

    if (errors) {
      each(errors, (value: any, key) => {
        if (value === true) {
          errors[key] = {};

          if (errors.actualValue) {
            errors[key].actualValue = errors.actualValue;
          }

          if (errors.requiredValue) {
            errors[key].requiredValue = errors.requiredValue;
          }
        }
      });

      // Remove non error key values
      [
        'actualValue',
        'requiredValue'
      ].forEach((key) => {
        delete errors[key];
      });
    }
  }
}
